<script>
import { rule_required, rule_email } from "@/plugins/validate";
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from "vee-validate";

setInteractionMode("eager");

[rule_required, rule_email].forEach(rule => {
  extend(rule.name, rule.options);
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  methods: {
    onErrorFocus(refname) {
      if (refname && this.$refs[refname] != null) {
        this.$nextTick(() => {
          const errors = Object.entries(this.$refs[refname].errors)
            .map(([key, value]) => ({ key, value }))
            .filter(error => error["value"].length);
          this.$refs[refname].refs[errors[0]["key"]].$el.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
        });
      }
    }
  }
};
</script>
